module.exports = __webpack_public_path__ + "media/img/pages/talent_career/hero-fr-84f984cdab15bc9169f90ca429cab426.jpg";